/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "utils";

import { ADMIN_ADMIN_USERS_URL as endpoint } from "consts";

import { AdminUser, AdminUserDetails, VerifyAdminUserResponseBody } from "models";

export const signinAdminUser = async (data: any) => axios.post(`${endpoint}/signin`, { data });

export const confirmAdminUser = async (data: any) => axios.post(`${endpoint}/confirm`, { data });

export const changeAdminPassword = async (data: any) => axios.post(`${endpoint}/password-reset`, { data });

export const verifyAdminUser = async (data: any): Promise<VerifyAdminUserResponseBody> => axios.get(`${endpoint}/verify`, { data });

export const getCurrentAdminUserData = async (data: any): Promise<AdminUserDetails> => axios.get(`${endpoint}/user-data`, { data });

export const getAllAdminUsers = async (data: { verifier: boolean }): Promise<AdminUser[]> => axios.get(`${endpoint}`, { data });

export const addUser = async (data: any) => axios.post(`${endpoint}`, { data });

export const getAdminUser = async (data: any) => axios.get(`${endpoint}/${data.id}`, { data });

export const updateUser = async (data: any) => axios.put(`${endpoint}/${data.id}`, { data });

export const sendPasswordReset = async (data: any) => axios.post(`${endpoint}/password`, { data });
